export default function Button({ children, onClick, className = '' }) {
  return (
    <button
      onClick={onClick}
      className={`bg-disfagiapp-blue hover:bg-disfagiapp-blue-hover text-white font-semibold px-6 py-3 rounded transition-colors ${className}`}
    >
      {children}
    </button>
  );
}